import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslationService } from '../../core';

@Component({
	template: require('./confirm-modal.component.html')
})
export class ConfirmModalComponent implements OnInit {
	@Input() options: ConfirmModalConfig;

	constructor(
		public activeModal: NgbActiveModal,
		private _translationService: TranslationService,
	) {
		if (!this.options) {
			this.options = { body: '' };
		}
	}

	ngOnInit() {
		if (!this.options) {
			this.options = { body: '' };
		}

		if (!this.options.title) {
			this.options.title = this._translationService.getString('Je vyžadováno potvrzení');
		}

		if (!this.options.btnContinueTxt) {
			this.options.btnContinueTxt = this._translationService.getString('Pokračovat');
		}

		if (!this.options.btnOkTxt) {
			this.options.btnOkTxt = this._translationService.getString('Ano');
		}

		if (!this.options.btnCancelTxt) {
			this.options.btnCancelTxt = this._translationService.getString('Ne');
		}

		if (this.options.showOk == null) {
			this.options.showOk = true;
		}

		if (this.options.showHeader == null) {
			this.options.showHeader = true;
		}

		if (this.options.showFooter == null) {
			this.options.showFooter = true;
		}
	}
}

export interface ConfirmModalConfig {
	title?: string;
	body: string;
	btnOkTxt?: string;
	showOk?: boolean;
	btnContinueTxt?: string;
	btnCancelTxt?: string;
	showContinue?: boolean;
	showHeader?: boolean;
	showFooter?: boolean;
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/confirm-modal.component.ts